/* unplugin-vue-components disabled */import { render } from "./RealFaceGuide.vue?vue&type=template&id=65721c0b&scoped=true"
import script from "./RealFaceGuide.vue?vue&type=script&lang=js"
export * from "./RealFaceGuide.vue?vue&type=script&lang=js"

import "./RealFaceGuide.vue?vue&type=style&index=0&id=65721c0b&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65721c0b"]])

export default __exports__